export function wasPageRefreshed() {
  const navEntries = window.performance.getEntriesByType("navigation");
  if (navEntries && navEntries.length > 0) {
    // @ts-expect-error
    return navEntries[0].type === "reload";
  }
  return false;
}

// Helper function to determine route based on job type
export function getJobTypeRoute(jobType: string): string {
  if (jobType === "mechanical") {
    return "mechanical";
  } else if (jobType === "composite") {
    return "composite";
  }
  // Default fallback to composite for backward compatibility
  return "composite";
}
